// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"styles_cancelButton__1tRGX"};